import React, { useState } from 'react';
import './userprofile.css'; 
import {FaHome, FaPhone, FaIdCard, FaAddressBook } from 'react-icons/fa'; 

const Profile = () => {
  const [selectedSection, setSelectedSection] = useState('Contact Details');

  // Function to handle sidebar item click
  const handleMenuClick = (section) => {
    setSelectedSection(section);
  };

  return (
    <div className="profile-wrapper">
      {/* Sidebar */}
      <div className="sidebar">
        <ul className="sidebar-menu">
          <li onClick={() => handleMenuClick('Contact Details')}>
            <FaPhone className="menu-icon" /> Contact Details
          </li>
          <li onClick={() => handleMenuClick('Addresses')}>
            <FaHome className="menu-icon" /> Addresses
          </li>
          <li onClick={() => handleMenuClick('Emergency Contacts')}>
            <FaAddressBook className="menu-icon" /> Emergency Contacts
          </li>
          
          <li onClick={() => handleMenuClick('Identification')}>
            <FaIdCard className="menu-icon" />  Identification Number
          </li>
        </ul>
      </div>

      {/* Profile Section */}
      <div className="profile-section">
        <h2>{selectedSection}</h2>
        <div className="profile-container">
          <img src="profile-pic-url" alt="User" className="profile-pic" />
          <div className="profile-info">
            {/* Conditionally render content based on the selected section */}
            {selectedSection === 'Contact Details' && (
              <>
                <p><strong>Email:</strong> johndoe@example.com</p>
                <p><strong>Phone:</strong> +1 234 567 8901</p>
              </>
            )}
            {selectedSection === 'Addresses' && (
              <>
                <p><strong>Home Address:</strong> 123 Main St, Springfield</p>
              </>
            )}
            {selectedSection === 'Emergency Contacts' && (
              <>
                <p><strong>Emergency Contact:</strong> Jane Doe, +1 987 654 3210</p>
              </>
            )}
            
            {selectedSection === 'Identification' && (
              <>
                <p><strong>ID Number:</strong> ABC123456</p>
                <p><strong>Ref Number:</strong> 9876543210</p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
